import classNames from "classnames";

import Icon from "../../assets/svg";

import DropDown from "../../components/dropdown";

interface ExportOption {
  name: string;
  action: () => void;
}

type Props = {
  size?: "small" | "large";
  exportOptions: ExportOption[];
  disabled?: boolean;
};

const ExportData = ({ size, exportOptions, disabled }: Props) => {
  return (
    <div className="export_data_container">
      <DropDown
        toggler={
          <div
            className={classNames("export_data", {
              small: size === "small",
              disabled,
            })}
          >
            <Icon name="upload" />
            <p>Export Data</p>
          </div>
        }
      >
        {!disabled && (
          <div className="export_options">
            {exportOptions?.map((option: ExportOption) => (
              <div className="option" onClick={option.action}>
                <p>{option?.name}</p>
              </div>
            ))}
          </div>
        )}
      </DropDown>
    </div>
  );
};

export default ExportData;
